import { AsnState } from '../../interfaces/Asn/AsnState'
import { AsnStateAction } from '../actions/asnStateActions'
import { GET_ASN_STATE_EXITO } from '../types/asnStateActionsTypes'

export interface AsnStatesState {
  asnStatesState: {
    asnState?: AsnState[]
    error?: string | undefined
  }
}

const initialState: AsnStatesState = {
  asnStatesState: { asnState: [], error: '' }
}

export const asnStateReducer = (
  state: AsnStatesState = initialState,
  action: AsnStateAction
): AsnStatesState => {
  if (action.type === GET_ASN_STATE_EXITO) {
    return {
      ...state,
      asnStatesState: {
        asnState: action.asnState,
        error: action.error
      }
    }
  }
  return state
}
